<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.category_type"
        placeholder="房态来源类型"
        clearable
        style="width: 150px"
        class="filter-item"
        size="small"
      >
        <el-option
          v-for="item in targetTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input
        v-model="listQuery.category_type_level"
        placeholder="来源级别"
        style="width: 120px"
        class="filter-item"
        size="small"
        clearable
        type="number"
      />
      <el-select
        v-model="listQuery.is_enabled"
        placeholder="状态"
        clearable
        style="width: 100px"
        class="filter-item"
        size="small"
      >
        <el-option label="启用" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-refresh"
        @click="handleReset"
        size="small"
        >重置</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate"
        size="small"
        v-if="$canEdit"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="80">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="客户端ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_client_id }}
        </template>
      </el-table-column>
      <el-table-column label="客户端名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_client?.name || '-' }}
        </template> </el-table-column
      ><el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.is_enabled == 1"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="房态来源" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getTargetTypeTagType(scope.row.category_type)">
            {{ getTargetTypeName(scope.row.category_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="来源级别" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.category_type_level }}
        </template>
      </el-table-column>
      <el-table-column label="库存过滤阈值" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.quota_limit === 0 ? '不限制' : scope.row.quota_limit }}
        </template>
      </el-table-column>
      <el-table-column label="入住起始提前天数" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.start_days }}
        </template>
      </el-table-column>
      <el-table-column label="入住结束提前天数" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_days }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="150"
        v-if="$canEdit"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleUpdate(scope.row)"
          >
            编辑
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="550px"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="140px"
        style="margin-left: 30px"
      >
        <el-form-item label="客户端ID" prop="app_client_id">
          <el-input v-model="form.app_client_id" disabled />
        </el-form-item>
        <el-form-item label="房态来源类型" prop="category_type">
          <el-select v-model="form.category_type" placeholder="请选择">
            <el-option
              v-for="item in targetTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="来源级别" prop="category_type_level">
          <el-input-number v-model="form.category_type_level" :min="0" />
        </el-form-item>
        <el-form-item label="库存过滤阈值" prop="quota_limit">
          <el-input-number v-model="form.quota_limit" :min="0" />
          <span style="margin-left: 10px; color: #999">0=不限制</span>
        </el-form-item>
        <el-form-item label="入住起始提前天数" prop="start_days">
          <el-input-number v-model="form.start_days" :min="0" />
        </el-form-item>
        <el-form-item label="入住结束提前天数" prop="end_days">
          <el-input-number v-model="form.end_days" :min="0" />
        </el-form-item>
        <el-form-item label="状态" prop="is_enabled">
          <el-select v-model="form.is_enabled" placeholder="请选择">
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { fetchTargetTypes, getTargetTypeName, getTargetTypeTagType } from '@/utils/targetType'
export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      appClientId: null,
      listQuery: {
        page: 1,
        limit: 10,
        app_client_id: undefined,
        category_type: undefined,
        category_type_level: undefined,
        is_enabled: undefined,
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '新增',
      },
      targetTypeOptions: [],
      form: {
        id: undefined,
        app_client_id: undefined,
        category_type: undefined,
        category_type_level: undefined,
        quota_limit: 0,
        start_days: undefined,
        end_days: undefined,
        is_enabled: 1,
      },
      rules: {
        app_client_id: [
          { required: true, message: '客户端ID不能为空', trigger: 'blur' },
        ],
        category_type: [
          { required: true, message: '请选择房态来源类型', trigger: 'change' },
        ],
        category_type_level: [
          { required: true, message: '请输入来源级别', trigger: 'blur' },
        ],
        quota_limit: [
          { required: true, message: '请输入库存过滤阈值', trigger: 'blur' },
        ],
        start_days: [
          {
            required: true,
            message: '请输入入住起始提前天数',
            trigger: 'blur',
          },
        ],
        end_days: [
          {
            required: true,
            message: '请输入入住结束提前天数',
            trigger: 'blur',
          },
        ],
        is_enabled: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
      btnLoading: false,
    }
  },
  async created() {
    this.appClientId = this.$route.query.app_client_id
    if (this.appClientId) {
      this.listQuery.app_client_id = parseInt(this.appClientId)
    }
    this.getList()
    this.targetTypeOptions = await fetchTargetTypes()
  },
  methods: {
    getTargetTypeName: getTargetTypeName,
    getTargetTypeTagType: getTargetTypeTagType,
    getList() {
      this.listLoading = true
      const params = { ...this.listQuery }
      if (params.app_client_id === '') {
        params.app_client_id = undefined
      }
      request({
        url: '/api/backend/app-client-hotel-permission-category-quota-limit/list',
        method: 'get',
        params,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        app_client_id: this.appClientId,
        category_type: undefined,
        category_type_level: undefined,
        is_enabled: undefined,
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: undefined,
        app_client_id: this.appClientId,
        category_type: undefined,
        category_type_level: undefined,
        quota_limit: 0,
        start_days: undefined,
        end_days: undefined,
        is_enabled: 1,
      }
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleUpdate(row) {
      this.form = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client-hotel-permission-category-quota-limit/delete',
            method: 'post',
            data: { id: row.id },
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleStatusChange(row) {
      const newStatus = row.is_enabled == 1 ? 0 : 1
      const statusText = newStatus === 1 ? '启用' : '禁用'
      this.$confirm(`确定要${statusText}该配置吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client-hotel-permission-category-quota-limit/change-status',
            method: 'post',
            data: { id: row.id, is_enabled: newStatus },
          })
            .then(() => {
              row.is_enabled = newStatus
              this.$message({
                type: 'success',
                message: '状态更新成功',
              })
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '状态更新失败',
              })
            })
        })
        .catch(() => {
          // 取消操作，不做处理
        })
    },
    saveData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.end_days < this.form.start_days) {
            this.$message({
              type: 'error',
              message: '入住结束提前天数不能小于入住起始提前天数',
            })
            return
          }
          this.btnLoading = true
          request({
            url: '/api/backend/app-client-hotel-permission-category-quota-limit/store',
            method: 'post',
            data: this.form,
          })
            .then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
